import React, { FC, useEffect, useState } from "react";
import { useFormik } from "formik";
import CustomButton from "../../components/UI/Buttons/CustomButton";
import {
  useAppSelector as useSelector,
  useAppDispatch as useDispatch,
} from "../../store";
import { resendInvitationThunk } from "../../store/auth/thunks";
import { createValidationSchema } from "../../utils/createValidationSchema";
import { TSentInvitationFormValues } from "../../models/form";
import CryptoJS from "crypto-js";
import { secretKet } from "../../constants/app";
import { isFulfilled } from "@reduxjs/toolkit";
import ErrorMessage from "../../components/UI/Tooltips/ErrorMessage";
import EmailIcon from "../../components/UI/Icons/EmailIcon";
import { setShowSignUpDetails } from "../../store/auth/slice";

interface SentInvitationProps {}

const SentInvitation: FC<SentInvitationProps> = () => {
  const dispatch = useDispatch();

  const errors = useSelector((state) => state.auth.error);
  const inProgress = useSelector((state) => state.auth.inProgress);

  const eMail = sessionStorage.getItem("signup_email");
  // const bytes = CryptoJS.AES.decrypt(encryptedText as string, secretKet);
  // const eMail = bytes.toString(CryptoJS.enc.Utf8);

  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  // submit the form for sentInvitation
  const { handleSubmit, setFieldValue } = useFormik({
    validationSchema: createValidationSchema("sentInvitation"),
    initialValues: {
      email: "",
    },
    onSubmit: async (values: TSentInvitationFormValues) => {
      const payload = { ...values };
      try {
        const result = await dispatch(resendInvitationThunk(payload));
        if (isFulfilled(result)) {
          setShowSuccessMessage(!false);
        }
      } catch (error) {
        throw new Error(
          "Could not connect to services at the moment. Please try again. Thanks."
        );
      }
    },
  });

  useEffect(() => {
    setFieldValue("email", eMail);

    if (errors && errors.message === "Email is already verified.") {
      setIsDisabled(true);
    }

    dispatch(setShowSignUpDetails(false));
  }, [dispatch, eMail, setFieldValue, errors]);

  return (
    <>
      <div className="d-flex flex-column gap-30 gap-mobile-20 align-items-center">
        <div className="d-flex flex-column gap-10 align-items-center">
          <EmailIcon />
          <div className="d-flex flex-column gap-30 align-items-center">
            <div className="fs-16 fw-400 text-black text-center">
              An email has been sent to <br />
              <span className="fw-700 text-break">{eMail}</span>
            </div>
            <div className="d-flex flex-column align-items-center">
              <div className="fs-16 fw-400 text-black">
                Please click the link in the email to
              </div>
              <div className="fs-16 fw-400 text-black">verify your account</div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column gap-5 align-items-center">
          <div className="fs-13 fw-400 text-grey-medium">
            Not in your inbox or junk?
          </div>
          <CustomButton
            type="submit"
            variant="primary"
            isLoading={inProgress}
            contentClass="d-flex"
            disabled={isDisabled}
            className="fw-600 btn-theme bg-teal text-black min-w-250px"
            onClick={handleSubmit}
          >
            Resend Email
          </CustomButton>
          {errors && <ErrorMessage message={errors.message} />}
          {showSuccessMessage && !isDisabled && (
            <div
              className="d-flex flex-column align-items-center"
              style={{ color: "#34ada3" }}
            >
              The email has been sent successfully!
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SentInvitation;
